export default __webpack_public_path__ + "static/media/regulatory--vehicles-carrying-explosives-only--g1.1ecbe4c0.png";